import { AbstractShowEntityComponent } from '@abstracts/entities/show-entity';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EnableFreeChargeDialogContentComponent } from '@components/dialog/enable-free-charge-dialog-content/enable-free-charge-dialog-content.component';
import { EnablePublicChargeDialogContentComponent } from '@components/dialog/enable-public-charge-dialog-content/enable-public-charge-dialog-content.component';
import { EnablePrivateChargeDialogContentComponent } from '@components/dialog/enable-private-charge-dialog-content/enable-private-charge-dialog-content.component';
import { DiagnosticChargingStationDialogContentComponent } from '@components/dialog/diagnostic-charging-station-dialog/diagnostic-charging-station-dialog-content/diagnostics-charging-station-dialog-content.component';
import { ChargingStation } from '@models/charging-station';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { UsersService } from '@services/entity/users.service';
import { plainToClass } from 'class-transformer';
import { RemoteStartStopDialogContentComponent } from '@components/dialog/remote-start-stop-dialog-content/remote-start-stop-dialog-content.component';
import { ChargingPower } from '../../../../models/chargingPower';
import { ConnectorSystems } from '../../../../models/connectorSystems';
import { Manufacturer } from '../../../../models/manufacturer';
import { ToastService } from '@services/toast/toast.service';
import { Subscription } from 'rxjs';
import { Model } from '../../../../models/model';
import { Profile } from '../../../../models/profile';
import { DEDatePipe } from 'src/app/pipes/de-date.pipe';
import { QRCodeElementType } from 'angularx-qrcode';
import { CustomersTableEntry } from '../../../../dto/customersTableEntry';
import { RfidCard } from '../../../../models/rfidCard';
import { FormService } from '../../../../services/form/form.service';
import { ChargingPointDto } from '@dto/chargingPointDto';
import { statusUpdateEvent } from '@dto/statusUpdateEvent';
import { ChargingPoint } from '../../../../models/chargingPoint';
import { isEmpty } from 'rxjs/operators';

@Component({
  selector: 'app-charging-station-info',
  templateUrl: './charging-station-info.component.html',
  styleUrls: ['./charging-station-info.component.scss'],
})
export class ChargingStationInfo extends AbstractShowEntityComponent implements OnInit {

  public className = 'ChargingStationInfo';
  public entity: ChargingStation;
  public freeChargeStatus: boolean;
  public publicChargeStatus: boolean;
  public privateChargeStatus: boolean;
  public isOperator: boolean = false;
  public isCustomer: boolean = false;
  public isUser: boolean = false;
  public isSupporter: boolean = false;
  public qrCodeUrl: string = '';
  public elementType: QRCodeElementType = "img";
  public oldId: number;
  public currentChargeMode: any;
  private modes: string[] = [];
  public status: number[] = [];
  public reservation: string[] = [];
  public operatorId: string;
  public reservationLeft: string;
  public reservationRight: string;

  chargingPowers: ChargingPower[] = [];
  connectorSystems: ConnectorSystems[] = [];
  manufacturers: Manufacturer[] = [];
  customers: CustomersTableEntry[] = [];
  models: Model[] = [];
  model: Model[] = [];
  profile: Profile;
  profiles: Profile[] = [];
  chargingPoints: ChargingPointDto[] = [];


  showFreeChargeText: boolean;
  lat: string;
  lon: string;
  changeCustomer: boolean = false;
  oldCsId: number;
  rfidcard: RfidCard;
  freeCharge: boolean = false;
  authorizeCharge: boolean = false;
  publicCharge: boolean = false;
  canRemoteStart: boolean = true;
  showPublicChargeHint: boolean = false;

  ButtonText: string[] = [];
  ToolTipText: string[] = [];
  bgcolor: string[] = [];
  canCharging: boolean[] = [];
  showReservationBtn: boolean[] = [];
  showCancelReservationBtn: boolean[] = [];

  @Input() isAvailable: boolean;

  constructor(
    private chargingStationsService: ChargingStationsService,
    public formService: FormService,
    private usersService: UsersService,
    private dialog: NgbModal,
    private toastService: ToastService,
    public injector: Injector
  ) {
    super(chargingStationsService, injector);
  }

  ngOnInit() {
    this.authenticationService.getLoggedInUserSubject().subscribe(res => {
      this.operatorId = res.id;
    });
    super.ngOnInit();
  }

  showReservationButton(cp: ChargingPoint) {
    if ((this.isUser) && cp?.reservedUntil == null && cp?.statusId == 2) {
      this.showReservationBtn[cp?.connectorId] = true;
      return true;
    } else {
      this.showReservationBtn[cp?.connectorId] = false;
      return false;
    }
  }

  showCancelReservationButton(cp: ChargingPoint) {
    if (cp?.reservedUntil != null) {
      this.showCancelReservationBtn[cp?.connectorId] = true;
      return true;
    } else {
      this.showCancelReservationBtn[cp?.connectorId] = false;
      return false;
    }
  }

  getAdditionalEntities() {
    this.chargingStationsService.statusUpdateEventEmitter.subscribe((event: statusUpdateEvent) => {
      this.initializeChargingPoints()
    });
  }

  initializeEntity(entity) {
    this.getRoles();
    this.entity = plainToClass(ChargingStation, entity);
    this.initializeChargingPoints();
    if (this.isUser) { this.checkCanRemoteStart() }
    this.getModus();
    this.qrCodeUrl = `${window.location.origin}/pc?cs=${this.entity.id}`
    this.oldId = this.entity.customerId;
  }

  initializeChargingPoints() {
    this.chargingStationsService.getChargingPointsOfChargingStation(this.primaryKey).subscribe(result => {
      this.chargingPoints = result
      this.updateButtonConditions()
    }, error => { console.error(error) })
  }

  afterInit() {
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.isCustomer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.isOperator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.isUser = true;
    }
    this.isSupporter = this.authenticationService.userHasRole('Supporter')
  }

  checkCanRemoteStart() {
    this.chargingStationsService.checkCanRemoteStart(this.entity.id).subscribe(result => {
      this.canRemoteStart = result;
      this.showPublicChargeHint = !result && this.entity.isPublicCharge;
      this.updateButtonConditions();
    }, error => { });
  }

  getProfile() {
    this.chargingStationsService.getProfile(this.entity.model.profileId).subscribe(result => {
      this.profile = result;
    }, error => { });
  }

  NewUpateButtonConditions() {
    this.status = [];
    this.chargingPoints.forEach((chargingPoint: any, index: number) => {
      this.status.push(chargingPoint.connectorId);
    })
  }

  updateButtonConditions() {
    this.chargingPoints.forEach((chargingPoint: ChargingPoint, index: number) => {
      // if charging station is not available, display all points as n/a
      if (this.entity.status.id != ChargingPointStatusEnum.Available) {
        this.ButtonText[chargingPoint.connectorId] = 'Ladestation nicht verfügbar';
        this.bgcolor[chargingPoint.connectorId] = 'bg-secondary text-white disabled';
        return;
      }

      // if charging station is available show each point's status
      if (this.canRemoteStart) {
      this.showReservationButton(chargingPoint);
      this.showCancelReservationButton(chargingPoint);
        switch (chargingPoint.status.id) {
          case ChargingPointStatusEnum.Available: { this.ButtonText[chargingPoint.connectorId] = 'Ladevorgang freigeben'; this.bgcolor[chargingPoint.connectorId] = 'hero bg-primary'; this.canCharging[chargingPoint.connectorId] = true; return };
          case ChargingPointStatusEnum.Finishing: { this.ButtonText[chargingPoint.connectorId] = 'Ladevorgang freigeben'; this.bgcolor[chargingPoint.connectorId] = 'hero bg-primary'; this.canCharging[chargingPoint.connectorId] = true; return };
          case ChargingPointStatusEnum.Preparing: { this.ButtonText[chargingPoint.connectorId] = 'Ladevorgang freigeben'; this.bgcolor[chargingPoint.connectorId] = 'hero bg-primary'; this.canCharging[chargingPoint.connectorId] = true; return };
          case ChargingPointStatusEnum.Reserved: { this.ButtonText[chargingPoint.connectorId] = 'Ladepunkt ist reserviert'; this.bgcolor[chargingPoint.connectorId] = 'hero blue'; this.canCharging[chargingPoint.connectorId] = true; this.updateReservations(chargingPoint); return };
          case ChargingPointStatusEnum.Charging:
          case ChargingPointStatusEnum.SuspendedEV:
          case ChargingPointStatusEnum.SuspendedEVSE: { this.ButtonText[chargingPoint.connectorId] = 'Ladevorgang stoppen'; this.bgcolor[chargingPoint.connectorId] = ' hero bg-warning'; this.canCharging[chargingPoint.connectorId] = false; return };
          default: { this.ButtonText[chargingPoint.connectorId] = 'Ladepunkt nicht verfügbar'; this.bgcolor[chargingPoint.connectorId] = 'bg-secondary text-white disabled'; return };
        }
      } else {
        this.showPublicChargeHint = this.entity.isPublicCharge;
        this.ToolTipText[chargingPoint.connectorId] = this.entity.isPublicCharge
          ? 'Sie sind für diese Station nicht freigeschaltet. Nutzen Sie QR-Code-Laden.'
          : 'Ladepunkt ' + chargingPoint.connectorId + ' ist nicht erlaubt, entweder fehlt die RFID-Karte oder die Zahlungsmethode';
        this.ButtonText[chargingPoint.connectorId] = this.entity.isPublicCharge ? 'QR-Code-Laden nutzen' : 'Ladepunkt nicht verfügbar';
        this.bgcolor[chargingPoint.connectorId] = this.entity.isPublicCharge ? 'hero bg-primary' : ' bg-secondary text-white disabled';
        this.canCharging[chargingPoint.connectorId] = false;
        this.showReservationBtn[chargingPoint?.connectorId] = false;
        this.showCancelReservationBtn[chargingPoint?.connectorId] = false;
        return;
      }
    })
  }

  updateReservations(cp: ChargingPoint) {
    console.log(cp?.connectorId);
    const datePipe = new DEDatePipe();
    const reservationMessage = `reserviert bis ${datePipe.transform(cp.reservedUntil)}`
    this.ButtonText[cp.connectorId] = reservationMessage;
    console.log(this.ButtonText[cp.connectorId]);
  }

  getModus() {
    this.freeChargeStatus = this.entity.isFreeCharge;
    this.privateChargeStatus = this.entity.isPrivateCharge;
    this.publicChargeStatus = this.entity.isPublicCharge;

    if (this.entity?.chargingPoints[0].statusId != 1 && this.entity.chargingPoints[0].statusId != 10 && this.entity.chargingPoints[0].statusId != 11) {
      if (!this.isUser) {
        this.chargingStationsService.syncFreeChargeModeFromOcpp(this.primaryKey.toString()).subscribe(result => {
          if (result.isModeMismatched) {
            this.freeChargeStatus = result.isFreeCharge;
            if (result.isFreeCharge) {
              this.privateChargeStatus = false;
              this.publicChargeStatus = false;
            } else {
              this.privateChargeStatus = true;
              this.publicChargeStatus = false;
            }
          }
        }, error => {
        })
      }
    }

    this.modes = [];
    if (this.freeChargeStatus) {
      this.modes.push('free');
      this.currentChargeMode = 'free';
      this.freeCharge = true;
    }
    if (this.privateChargeStatus) {
      this.modes.push('authorize');
      this.currentChargeMode = 'authorize';
      this.authorizeCharge = true;
    }
    if (this.publicChargeStatus) {
      this.modes.push('public');
      this.currentChargeMode = 'public'
      this.publicCharge = true;
    }
  }

  openPrivateChargeDialog(mode: string) {
    const dialogRef = this.dialog.open(EnablePrivateChargeDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.chargingStation = this.entity;
    dialogRef.componentInstance.mode = mode;
    dialogRef.componentInstance.currentStatus = this.privateChargeStatus;

    dialogRef.result.then((result) => {
    }, (backdrop) => {
    });
  }

  openPublicChargeDialog(mode: string) {
    const dialogRef = this.dialog.open(EnablePublicChargeDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.chargingStation = this.entity;
    dialogRef.componentInstance.mode = mode;
    dialogRef.componentInstance.currentStatus = this.publicChargeStatus;

    dialogRef.result.then((result) => {
    }, (backdrop) => {
    });
  }

  openChangeFreeChargeDialog() {
    const dialogRef = this.dialog.open(EnableFreeChargeDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.chargingStation = this.entity;
    dialogRef.componentInstance.currentStatus = this.freeChargeStatus;

    dialogRef.result.then((result) => {
      if (result.state == 'failure') {
        this.getModus();
      }
      dialogRef.close();
    });
  }

  openRemoteStartStopDialog(start: boolean, connector?: number) {
    if (!this.canRemoteStart && this.entity.isPublicCharge) {
      this.router.navigate(['/pc'], { queryParams: { cs: this.entity.id } });
      return;
    }

    const dialogRef = this.dialog.open(RemoteStartStopDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.start = start;
    dialogRef.componentInstance.chargingPointConnectorId = connector;
    dialogRef.componentInstance.chargingStation = this.entity;
    dialogRef.componentInstance.chargingWillBeAssignedToUser = this.isUser;

    dialogRef.result.then((result) => {
      dialogRef.close();
    });
  }

  openDiagnosticsDialog(): void {
    const dialogRef = this.dialog.open(DiagnosticChargingStationDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.entity = this.entity;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }

  copysuccess(string) {
    this.toastService.success(string + ' wurde in die Zwischenablage kopiert.');
  }


  setChargingStationReserved(connectorId) {
    this.toastService.info('Reservierung wird angefragt...', 3500, true);
    let reservationDate = new Date();
    reservationDate.setMinutes(reservationDate.getMinutes() + 30);
    this.chargingStationsService.reserveChargingStation(this.entity.id, connectorId).subscribe(result => {
      if (Boolean(result)) {
        this.toastService.success('Reservierung erfolgreich.', 2000, true);
        this.initializeChargingPoints();
      } else {
        this.toastService.error('Reservierung fehlgeschlagen.', 2000, true);
      }
    }, error => {
      if (typeof error === 'string' && error.includes('The idTag parameter is required and cannot be null')) {
        this.toastService.error('Keine verfügbaren RFID-Karten vorhanden.', 2000, true);
      } else {
        this.toastService.error('Reservierung fehlgeschlagen.', 2000, true);
      }
    })
  }

  cancelChargingStationReservation(connectorId) {
    this.toastService.info('Reservierung wird storniert.', 3500, true);
    this.chargingStationsService.cancelReservationChargingStation(this.entity.id, connectorId).subscribe(
      result => {
        if (Boolean(result)) {
          this.initializeChargingPoints();
          this.toastService.info('Stornierung erfolgreich.', 2000, true);
        } else {
          this.toastService.error('Stornierung fehlgeschlagen.', 2000, true);
        }
      }, error => {
        this.toastService.error('Stornierung fehlgeschlagen.', 2000, true);
      })
  }

  getModel(manufacturerId) {
    this.model = this.models.filter(x => x.manufacturerId == manufacturerId);
  }


  downloadQrCode(parent: any) {
    let parentElement = null

    if (this.elementType === "canvas") {
      // fetches base 64 data from canvas
      parentElement = parent.qrcElement.nativeElement
        .querySelector("canvas")
        .toDataURL("image/png")
    } else if (this.elementType === "img" || this.elementType === "url") {
      // fetches base 64 data from image
      // parentElement contains the base64 encoded image src
      // you might use to store somewhere
      parentElement = parent.qrcElement.nativeElement.querySelector("img").src
    } else {
      alert("Set elementType to 'canvas', 'img' or 'url'.")
    }

    if (parentElement) {
      // converts base 64 encoded image to blobData
      let blobData = this.convertBase64ToBlob(parentElement)
      // saves as image
      const blob = new Blob([blobData], { type: "image/png" })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      // name of the file
      link.download = "QR-Code"
      link.click()
    }
  }

  private convertBase64ToBlob(Base64Image: string) {
    // split into two parts
    const parts = Base64Image.split(";base64,")
    // hold the content type
    const imageType = parts[0].split(":")[1]
    // decode base64 string
    const decodedData = window.atob(parts[1])
    // create unit8array of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length)
    // insert all character code into uint8array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i)
    }
    // return blob image after conversion
    return new Blob([uInt8Array], { type: imageType })
  }

  changeMode(mode: string) {
    if (mode != null && mode != this.currentChargeMode) {
      switch (mode) {
        case 'free':
          this.openChangeFreeChargeDialog();
          break;
        case 'authorize':
          this.openPrivateChargeDialog('');
          break;
        case 'public':
          this.openPublicChargeDialog('');
      }
    }
  }

  doAllChargingPointsHavePublicKeys() {
    this.entity.chargingPoints.forEach(cp => {
      if (!cp.publicKey) return false;
    });
    return true;
  }

  getChargingPointCountText() {
    if (this.chargingPoints.length === 1) {
      return '1 Ladepunkt';
    } else {
      return `${this.chargingPoints.length} Ladepunkte`
    }
  }
}

enum ChargingPointStatusEnum {
  Unregistered = 1,
  Available = 2,
  Charging = 3,
  Faulted = 4,
  Finishing = 5,
  Preparing = 6,
  Reserved = 7,
  SuspendedEV = 8,
  SuspendedEVSE = 9,
  Unavailable = 10,
  Offline = 11
}
